module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-08.b231e570.png";